/* shizuku back-to-top (P15B). Horizon scrolls .page-wrapper on most
   templates (window elsewhere) — watch both, scroll both. */
(() => {
  const btn = document.getElementById('shz-back-to-top');
  if (!btn) return;

  const scroller = document.querySelector('.page-wrapper');
  const pos = () =>
    Math.max(window.scrollY || 0, scroller ? scroller.scrollTop : 0);

  const toggle = () => {
    btn.classList.toggle('shz-back-to-top--visible', pos() > window.innerHeight);
  };

  window.addEventListener('scroll', toggle, { passive: true });
  if (scroller) scroller.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', () => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
    window.scrollTo({ top: 0, behavior });
    if (scroller) scroller.scrollTo({ top: 0, behavior });
  });
})();
